import ApiResponseUnmapper from '@/libraries/DigiTickets/Api/ApiResponseUnmapper';
import Hydrator from '@/lib/Hydration/Hydrator';
import logFactory from '@/libraries/DigiTickets/Logging/logFactory';
import Offer from '@/lib/Offers/Offer';

export class OfferService {
    /**
     * @param {ApiClient} apiClient
     * @param {ApiRequestParams} apiRequestParams
     */
    constructor(
        apiClient,
        apiRequestParams
    ) {
        this.apiClient = apiClient;
        this.apiRequestParams = apiRequestParams;

        this.log = logFactory('OfferService');
    }

    /**
     * @param {string} offerCode
     *
     * @return {Promise<{Offer}>}
     */
    remoteFindOfferByCode(offerCode) {
        return this.apiClient
            .request(
                'GET',
                'offers',
                {
                    ...this.apiRequestParams.defaultMappers(),
                    offerCode,
                    // There could be 1000s of offer codes, but we only care about the code we are searching for.
                    // We don't resolve * which means we don't get all other offerscodes we don't care about,
                    // instead, the OfferPresenter will just append the code we care about.
                    resolve: 'items,dependentitems,categories,events',
                }
            )
            .then((response) => ApiResponseUnmapper.transformApiResponse(response.data, 'Offer'))
            .then((data) => {
                if (data.length === 0) {
                    return null;
                }

                const hydrator = new Hydrator();

                // There should only ever be 1 result.
                let offer = hydrator.hydrate(
                    data[0],
                    new Offer()
                );

                offer.code = data?.[0]?.offerscodes?.[0]?.code;

                return offer;
            });
    }
}
